import * as React from 'react';
import { useGetCordwoodQuery } from "../../../apis/Cordwood.api";
import { PrimaryCordwood, Cordwood } from "../../../types/models/Cordwood";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Cordwood;
};

export const CordwoodNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.timberKey }
                    {data?.internalKey && <> | </> }{ data?.internalKey }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const CordwoodName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetCordwoodQuery(PrimaryCordwood.fromId(id))
    return (<CordwoodNameDisplay data={data}/>)
}

export default CordwoodName;
